// extracted by mini-css-extract-plugin
module.exports = {"heading":"CampaignModal_heading__GDdWv","wrapper":"CampaignModal_wrapper__YsWnx","row":"CampaignModal_row___YHyT","row__inner":"CampaignModal_row__inner__El8vd"};